import { LegalEntitiesCommandsService_legalEntityCommandVersionServiceGetEntities } from '@festina/legalentity-general-types/legalentity/hooks/LegalEntitiesCommandsService_legalEntityCommandVersionServiceGetEntities'

export const useFetchCrmEntityEvents =
  LegalEntitiesCommandsService_legalEntityCommandVersionServiceGetEntities.useSuspenseQuery
